import { Flex, Icon, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { LocationSortMode, LocationSortOption } from '../../location-store';
import React from 'react';
import { CommonSize, getBasicCommonSize, getOneSizeSmaller } from '../../../common/helpers/utils';

type AddressHeaderProps = {
    currentSortMode?: LocationSortMode;
    sortOption: LocationSortOption;
    updateSort: (option: LocationSortOption) => void;
    width: string;
    children?: React.ReactNode;
    size?: CommonSize;
};

export const LocationTableHeaderV1: React.FC<AddressHeaderProps> = observer((props) => {
    const { currentSortMode, updateSort, width, sortOption, size } = props;

    const smallerSize = getOneSizeSmaller(size);

    return (
        <Flex
            pl={3}
            paddingY={2}
            w={width}
            borderRight={sortOption !== 'CROSS STREET' ? 'sm' : undefined}
            borderColor="border.default"
            color={currentSortMode?.option === sortOption ? 'brand.default' : 'text.primary'}
            onClick={() => updateSort(sortOption)}
        >
            <Text fontSize={smallerSize} fontWeight="bold">
                {props.children}
            </Text>

            {currentSortMode?.option === sortOption && (
                <Icon
                    size={getBasicCommonSize(smallerSize)}
                    icon={
                        currentSortMode?.direction === 'ASC' ? 'ArrowUpNarrow' : 'ArrowDownNarrow'
                    }
                />
            )}
        </Flex>
    );
});
